/* eslint-disable no-bitwise */

// Permissions for routes:
//  • Authenticated Only: ACCESS_AUTHENTICATED
//  • Unauthenticated Only: ACCESS_NOT_AUTHENTICATED
//  • Either: ACCESS_AUTHENTICATED | ACCESS_NOT_AUTHENTICATED
export const ACCESS_AUTHENTICATED = 1 << 1;
export const ACCESS_NOT_AUTHENTICATED = 1 << 2;
export const ACCESS_ADMIN = 1 << 3; // For future use\

// const NullComponent = () => '';

// NOTE: Wasn't sure what these were meant to be, and just wanted to get it merged
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
export const authenticationCheck = (authentication: any, member: any) =>
  (authentication & ACCESS_AUTHENTICATED && member) ||
  (authentication & ACCESS_NOT_AUTHENTICATED && !member) ||
  (authentication & ACCESS_ADMIN && member && member.hasAdminAccess);

export const MAP_URL = '/maps';
export const NOTIFICATIONS_PATH = 'you/notifications';
export const UNAUTHENTICATED_URL = `${MAP_URL}/login`;

// The url we redirect to if the user gets to '/'
export const START_URL = MAP_URL;
export const SIGN_UP_URL = `${MAP_URL}/sign-up`;
